import {
  CONTACT_CREATE_REQUEST,
  CONTACT_CREATE_SUCCESS,
  CONTACT_CREATE_FAIL,
  CONTACT_LIST_REQUEST,
  CONTACT_LIST_SUCCESS,
  CONTACT_LIST_FAIL,
  CONTACT_CREATE_REQUEST2,
  CONTACT_CREATE_FAIL2,
  CONTACT_CREATE_SUCCESS2,
  CONTACT_DETAILS_REQUEST,
  CONTACT_DETAILS_SUCCESS,
  CONTACT_DETAILS_FAIL,
} from "../constants/contactConstants";
import { api2 } from "../core/api";

export const insertContact = (contactjson) => async (dispatch) => {
  try {
    dispatch({
      type: CONTACT_CREATE_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.post(
      "/contact/InsertContactForm",
      contactjson,
      config
    );

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: CONTACT_CREATE_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: CONTACT_CREATE_SUCCESS,
        payload: data?.id,
      });
    }
  } catch (error) {
    dispatch({
      type: CONTACT_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const insertContact_Fn = (contactjson) => async (dispatch) => {
  try {
    dispatch({
      type: CONTACT_CREATE_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.post("/contact/step1", contactjson, config);

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: CONTACT_CREATE_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: CONTACT_CREATE_SUCCESS,
        payload: data?.id,
      });
    }
  } catch (error) {
    dispatch({
      type: CONTACT_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const insertContact_Fn_Step2 = (contactjson) => async (dispatch) => {
  try {
    dispatch({
      type: CONTACT_CREATE_REQUEST2,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.post("/contact/step2", contactjson, config);

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: CONTACT_CREATE_FAIL2,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: CONTACT_CREATE_SUCCESS2,
        payload: data?.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: CONTACT_CREATE_FAIL2,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const contactDetails = (contactId) => async (dispatch) => {
  try {
    dispatch({
      type: CONTACT_DETAILS_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.post(`/contact/${contactId}`, config);

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: CONTACT_DETAILS_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: CONTACT_DETAILS_SUCCESS,
        payload: data?.Result[0],
      });
    }
  } catch (error) {
    dispatch({
      type: CONTACT_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};


